import { parseManufacturingQuantityText } from './quantity-text.js';
export function emptyManufacturingOrderCreateForm() {
    return {
        brandId: '',
        locationGroupId: '',
        dateScheduled: '',
        note: '',
        // No seed line: a product is added by picking one, so a blank row is never the starting state.
        lines: [],
    };
}
export function emptyManufacturingOrderLine() {
    return { partId: '', name: '', quantity: '', priorityId: '' };
}
function toScheduledDate(value) {
    const trimmed = value.trim();
    if (!trimmed)
        return '';
    const parsed = new Date(trimmed);
    // An unparseable date is passed through untouched so the server's own message names the field,
    // rather than being flattened to '' and reported as merely missing.
    return Number.isNaN(parsed.getTime()) ? trimmed : parsed.toISOString();
}
/**
 * Form values to the create mutation's input.
 *
 * No `splitQuantities`: a job is created as what it builds, and release decides how that is cut
 * into work orders.
 */
export function toCreateManufacturingOrderInput(values) {
    const note = values.note.trim();
    return {
        brandId: values.brandId,
        locationGroupId: values.locationGroupId,
        dateScheduled: toScheduledDate(values.dateScheduled),
        note: note || undefined,
        lines: values.lines.map((line) => ({
            partId: line.partId,
            name: line.name.trim(),
            quantity: parseManufacturingQuantityText(line.quantity) ?? 0,
            // Undefined rather than null: an unanswered picker is a line with no priority of its own,
            // which is what the schema already means by omitting the key.
            priorityId: line.priorityId === '' ? undefined : Number(line.priorityId),
        })),
    };
}
//# sourceMappingURL=create-mapper.js.map